<template>
    <div
        class="sticky top-0 z-50 w-full text-center"
        :class="currentBg.startsWith('bg-') ? currentBg : ''"
        :style="currentBg.startsWith('#') ? { backgroundColor: currentBg } : undefined"
    >
        <div class="container mx-auto flex h-[4.5rem] items-center gap-6 px-5 sm:px-8 lg:px-0">
            <div class="shrink-0">
                <a v-if="inertia" href="/">
                    <img src="/assets/logo.svg" alt="Nexa Interactives" class="h-12 w-auto">
                </a>
                <router-link v-else to="/">
                    <img src="/assets/logo.svg" alt="Nexa Interactives" class="h-12 w-auto">
                </router-link>
            </div>
            <div class="hidden flex-1 lg:block">
                <ul class="ml-10 flex items-center gap-7 font-medium text-base">
                    <li v-for="menu in menus" :key="menu.id">
                        <a v-if="inertia" :href="menu.url" class="text-nomad-primary transition-colors hover:text-black">{{ menu.text }}</a>
                        <router-link v-else :to="menu.url" class="text-nomad-primary transition-colors hover:text-black">{{ menu.text }}</router-link>
                    </li>
                </ul>
            </div>
            <div class="ml-auto flex items-center justify-end gap-3">
                <button-link url="/contact" :inertia="inertia">Let's Talk</button-link>
                <Menu class="block lg:hidden" :menus="menus" :inertia="inertia" />
            </div>
        </div>
    </div>
</template>
<script>
import Menu from '@/components/buttons/Menu.vue'
import ButtonLink from '../components/buttons/ButtonLink.vue';
import { RouterLink } from 'vue-router';
export default {
    components: {
        Menu,
        ButtonLink,
        RouterLink
    },
    props: {
        inertia: {
            type: Boolean,
            default: false
        },
        bg: {
            type: String,
            default: 'bg-nomad-light'
        }
    },
    data() {
        return {
            currentBg: this.bg,
            menus: [
                {
                    id: 1,
                    text: 'Services',
                    url: '/services'
                },
                {
                    id: 2,
                    text: 'Plans',
                    url: '/plans'
                },
                {
                    id: 4,
                    text: 'About',
                    url: '/about'
                },
                {
                    id: 3,
                    text: 'Contact',
                    url: '/contact'
                },

            ]
        }
    },
    created() {
         if (this.inertia) return;
       //console.log(this.$route.meta);
        //this.bg = this.$route.meta.bg ?? 'bg-nomad-light'
        this.$watch(
            ()=> this.$route.meta,
            () => {
                console.log(this.$route.meta);
                this.currentBg = this.$route.meta.bg ?? 'bg-nomad-light'
            }
        )
    },
    methods: {

    }
}
</script>